<template>
    <div>
        <el-card shadow="hover">
            <el-form inline :model="query" size="small">
                <div @keydown.enter="doQuery()">
                    <div style="float: left;">
                        <el-form-item>
                            <el-select v-model="query.pid" placeholder="请选择招聘计划" style="width:250px;" @change="doQuery">
                                <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="query.stat" placeholder="请选择查询状态" style="width:100px;" @change="doQuery">
                                <el-option label="所有信息" value="Normal"></el-option>
                                <el-option label="待审核" value="Wait"></el-option>
                                <el-option label="已通过" value="Pass"></el-option>
                                <el-option label="已驳回" value="Reject"></el-option>
                                <el-option label="已缴费" value="Paid"></el-option>
                                <el-option label="未打准考证" value="Zkz"></el-option>
                                <el-option label="未打面试单" value="Msd"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="query.aiv" placeholder="请选择面试状态" style="width:100px;" @change="doQuery">
                                <el-option label="所有信息" value="All"></el-option>
                                <el-option label="已加入" value="Y"></el-option>
                                <el-option label="未加入" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-has="'PlatAdmin,PlatAudit'">
                            <el-select v-model="query.unid" placeholder="请选择招聘单位" style="width:150px;" @change="doQuery" clearable>
                                <el-option v-for="unit in units" :key="unit.id" :label="unit.name" :value="unit.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-has="'PlatAdmin'">
                            <el-select v-model="query.ptid" placeholder="请选择招聘岗位" style="width:150px;" @change="doQuery" clearable>
                                <el-option v-for="rec in recs" :key="rec.id" :label="'[' + rec.code + '] ' + rec.name" :value="rec.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div style="float: right;">
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="考生姓名" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.mob" clearable placeholder="手机号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.idno" clearable placeholder="身份证号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.sno" clearable placeholder="报名序号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.zkzno" clearable placeholder="准考证号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" style="width: 100%">
                <el-table-column show-overflow-tooltip label="报名信息" width="200">
                    <template slot-scope="scope">
                        <p>
                            序号：
                            <span style="color: orange;">{{ scope.row.reg.sno }}</span>
                        </p>
                        <p>{{ scope.row.reg.name }} [{{ scope.row.reg.mob }}]</p>
                        <p>[{{ scope.row.reg.idno }}]</p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="岗位信息">
                    <template slot-scope="scope">
                        <p>
                            岗位：
                            <span>[{{ scope.row.post.code }}] {{ scope.row.post.name }}</span>
                        </p>
                        <p>
                            单位：
                            <span v-if="scope.row.post.dept">[{{ scope.row.post.dept }}]</span>
                            {{ scope.row.post.unit }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="初审状态">
                    <template slot-scope="scope">
                        <p>
                            状态：[
                            <span v-html="$options.filters.regState(scope.row.audit.fstat)"></span>
                            ]
                            <span v-if="scope.row.audit.fstat !== 'Wait'">审核人：{{ scope.row.audit.fname }}</span>
                        </p>
                        <p v-if="scope.row.audit.fstat !== 'Wait'">时间：{{ scope.row.audit.ftime }}</p>
                        <p v-if="scope.row.audit.fstat !== 'Wait'">说明：{{ scope.row.audit.fmemo }}</p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="复审状态">
                    <template slot-scope="scope">
                        <p>
                            状态：[
                            <span v-html="$options.filters.regState(scope.row.audit.lstat)"></span>
                            ]
                            <span v-if="scope.row.audit.lstat !== 'Wait'">审核人：{{ scope.row.audit.lname }}</span>
                        </p>
                        <p v-if="scope.row.audit.lstat !== 'Wait'">时间：{{ scope.row.audit.ltime }}</p>
                        <p v-if="scope.row.audit.lstat !== 'Wait'">说明：{{ scope.row.audit.lmemo }}</p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="免笔试">
                    <template slot-scope="scope">
                        <p v-if="scope.row.eflag" style="color:red;">免笔试</p>
                        <p v-if="!scope.row.eflag">需要笔试</p>
                        <p>准考证打印时间 ↴</p>
                        <p>{{ scope.row.zkzp || '未打印' }}</p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="付款信息">
                    <template slot-scope="scope">
                        <p>[{{ scope.row.paid.pid }}]</p>
                        <p>收款：{{ scope.row.paid.pamt }}</p>
                        <p style="color: red" v-if="scope.row.paid.ramt > 0">退款：{{ scope.row.paid.ramt }}</p>
                        <p v-else>退款：{{ scope.row.paid.ramt }}</p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="报名状态" width="200">
                    <template slot-scope="scope">
                        <p>
                            状态：[
                            <span v-html="$options.filters.regState(scope.row.state)"></span>
                            ]
                            <el-button v-if="scope.row.state === 'Wait' || scope.row.state === 'Reject' || platUser" type="warning" size="mini" @click.stop="doOpenAudit(scope.row.id, true)">
                                详情
                            </el-button>
                            <el-button v-else type="success" size="mini" @click.stop="doOpenAudit(scope.row.id, false)">
                                查看
                            </el-button>
                        </p>
                        <p>报名：{{ scope.row.rtime }}</p>
                        <p>缴费：{{ scope.row.ptime || '未缴费' }}</p>
                        <p>排座：{{ scope.row.vtime || '未排座' }}</p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="是否入场" width="200">
                    <template slot-scope="scope">
                        <p>
                            状态：[
                            <span v-if="scope.row.aflag" style="color: chocolate;">已入场</span>
                            <span v-else>未入场</span>
                            ]
                        </p>
                        <div v-if="scope.row.aflag">
                            <p>时间：{{ scope.row.atime }}</p>
                            <p>审核：{{ scope.row.auser }}</p>
                            <p>方式：{{ scope.row.atype }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="是否面试" width="200">
                    <template slot-scope="scope">
                        <template v-if="scope.row.aflag">
                            <p style="margin-top: 10px;" v-has="'PlatAdmin,PlatAudit,UnitAdmin'">
                                <el-button v-if="scope.row.aiv" type="danger" size="mini" @click.stop="doAivSet(scope.row, false)">
                                    取消面试
                                </el-button>
                                <el-button v-else type="warning" size="mini" @click.stop="doAivSet(scope.row, true)">
                                    加入面试
                                </el-button>
                            </p>
                            <p v-has="'PlatView'">
                                {{ scope.row.aiv ? '已加入面试' : '未加入面试' }}
                            </p>
                            <div v-if="scope.row.aiv">
                                <p>状态：{{ scope.row.aivin ? '已入场' : '未入场' }}</p>
                                <p>时间：{{ scope.row.aivintime }}</p>
                                <p>审核：{{ scope.row.aivuser }} [{{ scope.row.aivtype }}]</p>
                            </div>
                        </template>
                        <template v-else>未入场考试</template>
                        <p>面试单打印时间 ↴</p>
                        <p>{{ scope.row.aivp || '未打印' }}</p>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog :title="'报名详情 ' + refreshTimer + '秒后自动刷新以获取该考生的最新信息'" :visible.sync="infoVisible" fullscreen :close-on-click-modal="false" :close-on-press-escape="false">
            <div>
                <el-card>
                    <el-row :gutter="10">
                        <el-col :span="15">
                            <el-form label-width="80px">
                                <el-row :gutter="10">
                                    <el-col :span="6">
                                        <el-form-item label="考生姓名">
                                            <p class="i-info">{{ detail.reg.name }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="联系手机">
                                            <p class="i-info">{{ detail.reg.mob }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="报名序号">
                                            <p class="i-info">{{ detail.reg.sno }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="准考证号">
                                            <p class="i-info">{{ detail.reg.zkzno || '未生成' }}</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10">
                                    <el-col :span="6">
                                        <el-form-item label="身份证号">
                                            <p class="i-info">{{ detail.reg.idno }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="出生日期">
                                            <p class="i-info">{{ detail.reg.date }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="考生年龄">
                                            <p class="i-info">{{ detail.reg.age }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="考生性别">
                                            <p class="i-info">{{ detail.reg.gender }}</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10">
                                    <el-col :span="12">
                                        <el-form-item label="招聘岗位">
                                            <p class="i-info">[{{ detail.post.code }}] {{ detail.post.name }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="招聘单位">
                                            <p class="i-info">
                                                <span>{{ detail.post.unit }}</span>
                                                <span style="margin-left: 10px;" v-show="detail.post.dept">[{{ detail.post.dept }}]</span>
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10" v-if="detail.aflag">
                                    <el-col :span="6">
                                        <el-form-item label="是否入场">
                                            <p class="i-info">已入场</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="入场时间">
                                            <p class="i-info">
                                                {{ detail.atime }}
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="审核人员">
                                            <p class="i-info">
                                                {{ detail.auser }}
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="审核方式">
                                            <p class="i-info">
                                                {{ detail.atype }}
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10" v-if="detail.aiv">
                                    <el-col :span="6">
                                        <el-form-item label="是否入场">
                                            <p class="i-info">{{ detail.aivin ? '已入场' : '未入场' }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="入场时间">
                                            <p class="i-info">
                                                {{ detail.aivintime }}
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="审核人员">
                                            <p class="i-info">
                                                {{ detail.aivuser }}
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="审核方式">
                                            <p class="i-info">
                                                {{ detail.aivtype }}
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-col>
                        <el-col :span="3">
                            <div style="height: 100%; width: 100%; text-align: center;">
                                <p>近期证件照</p>
                                <el-image style="width: 105px; height: 130px; margin-top: 10px;" :src="detail.reg.himg" fit="cover">
                                    <div slot="placeholder" class="image-slot">
                                        加载中
                                        <span class="dot">...</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div style="height: 100%; width: 100%; text-align: center;">
                                <p>考场入场照</p>
                                <el-image style="width: 130px; height: 130px; margin-top: 10px;" :src="detail.aface" v-if="detail.aface" fit="cover">
                                    <div slot="placeholder" class="image-slot">
                                        加载中
                                        <span class="dot">...</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div style="height: 100%; width: 100%; text-align: center;">
                                <p>面试入场照</p>
                                <el-image style="width: 130px; height: 130px; margin-top: 10px;" :src="detail.aivface" v-if="detail.aivface" fit="cover">
                                    <div slot="placeholder" class="image-slot">
                                        加载中
                                        <span class="dot">...</span>
                                    </div>
                                </el-image>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card style="margin-top: 10px;">
                    <el-row type="flex" justify="space-between">
                        <el-col :span="8">
                            <el-popover v-if="detail.audit.fstat != 'Wait'" placement="top-start" :title="detail.audit.fname" width="400" trigger="hover" :content="'[' + detail.audit.ftime + ']' + detail.audit.fmemo">
                                <el-tag slot="reference" v-if="detail.audit.fstat === 'Pass'" type="success" effect="dark">初审已通过</el-tag>
                                <el-tag slot="reference" v-if="detail.audit.fstat === 'Reject'" type="danger" effect="dark">初审未通过</el-tag>
                            </el-popover>
                            <el-tag v-if="detail.audit.fstat === 'Wait'" type="warning" effect="dark">尚未初审</el-tag>

                            <el-divider direction="vertical"></el-divider>

                            <el-popover v-if="detail.audit.lstat != 'Wait'" placement="top-start" :title="detail.audit.lname" width="400" trigger="hover" :content="'[' + detail.audit.ltime + ']' + detail.audit.lmemo">
                                <el-tag slot="reference" v-if="detail.audit.lstat === 'Pass'" type="success" effect="dark">复审已通过</el-tag>
                                <el-tag slot="reference" v-if="detail.audit.lstat === 'Reject'" type="danger" effect="dark">复审未通过</el-tag>
                            </el-popover>
                            <el-tag v-if="detail.audit.lstat === 'Wait'" type="warning" effect="dark">尚未复审</el-tag>
                        </el-col>
                        <el-col :span="16">
                            <div style="float: right;">
                                <el-button type="danger" @click="doEflag" v-has="'PlatAdmin,PlatAudit'" v-if="!detail.eflag">设置免笔试</el-button>
                                <el-button type="success" @click="doEflag" v-has="'PlatAdmin,PlatAudit'" v-if="detail.eflag">设置笔试</el-button>
                                <el-button type="primary" @click="doOpenChange" v-has="'PlatAdmin,PlatAudit'" v-if="audit && detail.vtime === ''">更换岗位</el-button>
                                <el-button v-if="audit" type="warning" @click="doHimgDetect" v-has="'PlatAdmin,PlatAudit'">人像检测</el-button>
                                <el-button v-if="audit" type="success" v-has="'PlatAdmin,PlatAudit,UnitAdmin'" @click="doOpenPass">审核通过</el-button>
                                <el-button v-if="audit" type="danger" v-has="'PlatAdmin,PlatAudit,UnitAdmin'" @click="doOpenReject">审核驳回</el-button>
                                <el-button type="primary" @click="doPrintRegt" v-has="'PlatAdmin'">
                                    打印信息表
                                </el-button>
                                <el-button type="primary" v-if="detail.vtime" @click="doPrintZkzt" v-has="'PlatAdmin'">
                                    打印准考证
                                </el-button>
                                <el-button type="info" v-if="detail.vtime" @click="doPrintZkztR" v-has="'PlatAdmin'">
                                    刷新准考证
                                </el-button>
                                <el-button type="danger" v-has="'PlatAdmin'" @click="doCancel">
                                    作废删除
                                </el-button>
                                <el-button type="danger" v-has="'PlatAdmin'" @click="doRefund">
                                    退还报名费
                                </el-button>
                                <el-button type="info" plain @click="infoVisible = false">
                                    关 闭
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card style="margin-top: 10px;">
                    <div>
                        <el-form label-position="top">
                            <el-row :gutter="15">
                                <el-col :span="rf.lb === '本人简历' ? 24 : 6" v-for="rf in detail.regf" :key="rf.lb">
                                    <el-form-item :label="rf.lb">
                                        <p class="f-info" v-html="rf.vl"></p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-card>
            </div>
        </el-dialog>

        <el-dialog title="审核通过" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="passVisible" width="400px">
            <el-select v-model="memo" placeholder="请选择审核说明" style="width: 100%;">
                <el-option value="已核实，通过审核"></el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="passVisible = false">取 消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="doSubmit('Pass')">提交审核通过</el-button>
            </span>
        </el-dialog>
        <el-dialog title="审核驳回" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="rejectVisible" width="400px">
            <el-select v-model="memo" placeholder="请选择审核说明" style="width: 100%;">
                <el-option value="上传照片不符合要求或信息不完整"></el-option>
                <el-option value="学历不符合要求"></el-option>
                <el-option value="年龄不符合要求"></el-option>
                <el-option value="户籍不符合要求"></el-option>
                <el-option value="政治面貌不符合要求"></el-option>
                <el-option value="所学专业不符合要求"></el-option>
                <el-option value="工作年限不符合要求"></el-option>
                <el-option value="专业工作年限不符合要求"></el-option>
                <el-option value="其他原因"></el-option>
            </el-select>
            <el-input v-if="memo === '其他原因'" type="textarea" style="margin-top: 20px;" :rows="2" placeholder="请填写驳回原因" v-model="desc"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rejectVisible = false">取 消</el-button>
                <el-button type="danger" :loading="submitLoading" @click="doSubmit('Reject')">提交审核驳回</el-button>
            </span>
        </el-dialog>

        <el-dialog title="更换岗位" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="changeVisible" width="400px">
            <el-select v-model="cpid" placeholder="请选择要更换的岗位" style="width: 100%;">
                <el-option v-for="item in posts" :label="'[' + item.code + '] ' + item.name" :value="item.id" :key="item.id" :disabled="detail.post.id === item.id"></el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="changeVisible = false">取 消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="doChangePost">更换岗位</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<style scoped>
.i-info {
    width: 100%;
    color: #9358ac;
    font-size: 1em;
    padding: 5px;
    border-width: 1px;
    border-color: lightgrey;
    border-radius: 4px;
    border-style: dotted;
}
.f-info {
    color: #9358ac;
    padding: 5px;
    border-width: 1px;
    border-color: lightgrey;
    border-radius: 4px;
    border-style: dotted;
}
</style>

<script>
const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    pid: '',
    unid: '',
    ptid: '',
    stat: 'Normal',
    sno: '',
    idno: '',
    name: '',
    mob: '',
    zkzno: '',
    vid: '',
    aiv: 'All'
}

export default {
    name: 'RecRegs',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            refreshTimer: 30,
            nowid: null,
            tableLoading: false,
            datas: [],
            plans: [],
            units: [],
            recs: [],
            posts: [],
            changeVisible: false,
            cpid: '',
            passVisible: false,
            rejectVisible: false,
            infoVisible: false,
            submitLoading: false,
            detail: {
                reg: {},
                post: {},
                audit: {},
                regf: {}
            },
            memo: '',
            desc: '',
            audit: false
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['招聘管理', '报名信息'])
        this.init()
    },
    computed: {
        platUser() {
            return this.$has('PlatAdmin') || this.$has('PlatAudit')
        }
    },
    filters: {
        regState: value => {
            switch (value) {
                case 'Wait':
                    return '<b style="color:#800080;">审核中</b>'
                case 'Pass':
                    return '<b style="color:#008080;">已通过</b>'
                case 'Reject':
                    return '<b style="color:#FF0000;">已驳回</b>'
                case 'Paid':
                    return '<b style="color:#FF00FF;">已缴费</b>'
                case 'Finish':
                    return '<b style="color:#008080;">已排座</b>'
                case 'Cancel':
                    return '<b style="color:#FFFF00;">已作废</b>'
                case 'End':
                    return '<b style="color:#000000;">已结束</b>'
                default:
                    return value
            }
        }
    },
    methods: {
        init() {
            this.doLoadPlan()
        },
        doLoadUnit() {
            this.$http
                .get('/comm/data/unit/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.units = result.datas
                })
        },
        doLoadRec() {
            if (this.$has('PlatAdmin')) {
                this.$http
                    .get('/ops/recruit/post/list', {
                        params: {
                            page: 1,
                            size: 999,
                            time: new Date().getTime(),
                            pid: this.query.pid
                        }
                    })
                    .then(result => {
                        this.recs = result.datas
                    })
            }
        },
        doLoadPlan() {
            this.$http
                .get('/comm/data/plan/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    // 新建数据 把不符合条件的屏蔽掉
                    var x
                    var plans = []
                    for (x = 0; x < result.datas.length; x++) {
                        // console.log(result.datas[x].name)
                        if (
                            result.datas[x].name != '台前县2020年公开招聘事业人员' &&
                            result.datas[x].name != '台前县2020年公开招聘中小学幼儿园教师' &&
                            result.datas[x].name != '2022年台前县事业单位公开引进高层次和急需紧缺人才公告' &&
                            result.datas[x].name != '台前县2022年公开招聘事业人员'
                        ) {
                            plans.push(result.datas[x])
                        }
                    }
                    // console.log(plans)
                    this.plans = plans
                    // this.plans = result.datas
                    if (this.plans && this.plans.length > 0) {
                        this.query.pid = this.plans[0].id
                        this.doLoad()
                        this.doLoadUnit()
                        this.doLoadRec()
                    }
                })
        },
        doLoad() {
            this.tableLoading = true
            this.$http
                .get('/ops/recruit/reg/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    // 待屏蔽2023年之前
                    this.doLoadRec()
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            if (this.plans.length > 0) {
                this.query.pid = this.plans[0].id
            }

            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doOpenChange() {
            if (this.detail.id) {
                this.$http
                    .get('/comm/data/plan/posts', {
                        params: {
                            _: new Date().getTime() / 1000 / 60,
                            id: this.detail.pid
                        }
                    })
                    .then(result => {
                        this.posts = result.datas
                        this.changeVisible = true
                    })
            }
        },
        doEflag() {
            this.$http
                .post('/ops/recruit/reg/eflag/set', {
                    id: this.detail.id,
                    flag: !this.detail.eflag
                })
                .then(() => {
                    this.doLoad()
                    this.detail.eflag = !this.detail.eflag
                })
        },
        doChangePost() {
            if (this.detail.id) {
                this.$http
                    .post('/ops/recruit/reg/post/change', {
                        id: this.detail.id,
                        pid: this.cpid
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.changeVisible = false
                            this.$message.success('岗位已更换')
                            this.posts = []
                            this.$http
                                .get('/ops/recruit/reg/detail', {
                                    params: {
                                        id: this.detail.id
                                    }
                                })
                                .then(result => {
                                    this.detail = {
                                        ...result.data
                                    }
                                })
                        }
                    })
            }
        },
        doOpenAudit(id, audit) {
            this.$http
                .get('/ops/recruit/reg/detail', {
                    params: {
                        id: id
                    }
                })
                .then(result => {
                    this.detail = {
                        ...result.data
                    }
                    this.audit = audit
                    this.nowid = id
                    this.infoVisible = true
                })
        },
        doOpenPass() {
            if (this.detail.id) {
                this.memo = '已核实，通过审核'
                this.passVisible = true
            }
        },
        doOpenReject() {
            if (this.detail.id) {
                this.memo = '上传照片不符合要求或信息不完整'
                this.rejectVisible = true
            }
        },
        doHimgDetect() {
            this.$http
                .post('/ops/recruit/reg/himg/detect', {
                    id: this.detail.id
                })
                .then(result => {
                    if (result.code === 0) {
                        if (result.data.flag) {
                            this.$message.success('该考生照片通过人像检测')
                        } else {
                            this.$message.error('该考生照片不符合人像检测标准，建议驳回重传照片')
                        }
                    }
                })
        },
        doAivSet(item, flag) {
            this.$confirm('是否' + (flag ? '添加' : '取消') + '[' + item.reg.name + ']的面试邀请?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/reg/aiv/set', {
                        id: item.id,
                        flag: flag
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('操作成功')
                            this.doLoad()
                        }
                    })
            })
        },
        doCancel() {
            if (this.detail.id) {
                this.$confirm('是否作废[' + this.detail.reg.name + ']的报名申请?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .post('/ops/recruit/reg/cancel', {
                            id: this.detail.id
                        })
                        .then(result => {
                            if (result.code === 0) {
                                this.infoVisible = false
                                this.$message.success('操作成功')
                                this.doLoad()
                            }
                        })
                })
            }
        },
        doRefund() {
            if (this.detail.id) {
                this.$prompt('是否退还考生[' + this.detail.reg.name + ']的报名费用?', '提示', {
                    inputValue: '请填写退费原因',
                    confirmButtonText: '提交退款',
                    cancelButtonText: '取消'
                }).then(({ value }) => {
                    if (!value) {
                        this.$message.error('请填写退费原因')
                        return
                    }
                    this.$http
                        .post('/ops/recruit/reg/refund', {
                            id: this.detail.id,
                            cause: value
                        })
                        .then(result => {
                            if (result.code === 0) {
                                this.infoVisible = false
                                this.$message.success('操作成功')
                                this.doLoad()
                            }
                        })
                })
            }
        },
        doSubmit(act) {
            if (act === 'Reject' && this.memo === '其他原因' && !this.desc) {
                this.$message.error('请填写审核驳回原因')
                return
            }
            this.submitLoading = true
            this.$http
                .post('/ops/recruit/reg/audit', {
                    id: this.detail.id,
                    pass: act === 'Pass',
                    memo: act === 'Reject' && this.memo === '其他原因' ? this.desc : this.memo
                })
                .then(result => {
                    this.doLoad()
                    this.passVisible = false
                    this.rejectVisible = false
                    this.submitLoading = false
                    if (result.code === 0) {
                        if (result.data.next) {
                            this.$confirm('操作成功，是否继续审核下一个报名信息?', '提示', {
                                confirmButtonText: '继续审核',
                                cancelButtonText: '退出审核',
                                type: 'warning'
                            })
                                .then(() => {
                                    this.doOpenAudit(result.data.next, true)
                                })
                                .catch(() => {
                                    this.infoVisible = false
                                })
                        } else {
                            this.$message.success('操作成功')
                            this.infoVisible = false
                        }
                    }
                })
        },
        doPrintZkzt() {
            if (!this.detail.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/zkz', {
                    params: {
                        _: new Date().getTime(),
                        id: this.detail.id
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        },
        doPrintZkztR() {
            if (!this.detail.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/zkz', {
                    params: {
                        _: new Date().getTime(),
                        id: this.detail.id,
                        rebuild: true
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        this.$message.success('刷新成功')
                    }
                })
        },
        doPrintRegt() {
            if (!this.detail.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/table', {
                    params: {
                        _: new Date().getTime(),
                        id: this.detail.id
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        },
        doPrintNotice() {
            if (!this.detail.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/notice', {
                    params: {
                        _: new Date().getTime(),
                        id: this.detail.id
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        }
    },
    watch: {
        infoVisible: function(newinfoVisible) {
            if (newinfoVisible && this.nowid != null) {
                var _this = this
                var _timeer = this.refreshTimer
                this.a = window.setInterval(function() {
                    if (_timeer > 1) {
                        _timeer--
                    } else {
                        _timeer = 30
                    }
                    _this.refreshTimer = _timeer
                }, 1000)
                this.b = setInterval(function() {
                    _this.doOpenAudit(_this.nowid, _this.audit)
                }, _timeer * 1000)
            } else {
                clearInterval(this.a)
                clearInterval(this.b)
                this.refreshTimer = 30
            }
        }
    }
}
</script>
